import { AutoComplete, AutoCompleteProps, Form, FormItemProps } from 'antd';
import { useCallback, useMemo } from 'react';

import { AntSelectOption } from '../AntSelect';

interface Props extends AutoCompleteProps<any, AntSelectOption> {
  readonly formItemProps?: FormItemProps;
  readonly onSearchResult?: (values: any[]) => void;
}

const filterOption = (searchValue: string, option?: AntSelectOption) =>
  !!option?.label?.toString().toLowerCase().includes(searchValue.toLowerCase());

export const AntAutocomplete = ({ style, formItemProps, onSearchResult, onChange, options = [], ...props }: Props) => {
  const autocompleteOptions = useMemo(() => {
    return options.map(({ label }) => ({ label, value: label?.toString() }));
  }, [options]);

  const autocompleteOnChange = useCallback(
    (searchValue: string, searchOption?: AntSelectOption | AntSelectOption[]) => {
      const matchedOptions = searchValue
        ? options.filter((option) => filterOption(searchValue, option)).map(({ value }) => value)
        : [];

      onChange?.(searchValue, searchOption);
      onSearchResult?.(matchedOptions);
    },
    [options, onChange, onSearchResult],
  );

  return (
    <Form.Item style={style} {...formItemProps}>
      <AutoComplete<any, AntSelectOption>
        {...props}
        allowClear
        options={autocompleteOptions}
        onChange={autocompleteOnChange}
        filterOption={filterOption}
      />
    </Form.Item>
  );
};
